import { emailSchema } from "utils/validation/validationHelpers";
import { object } from 'yup';

const forgotPassSchema = object().shape({
  email: emailSchema,
});

export default forgotPassSchema;